import {createSelector} from "@reduxjs/toolkit";
import AuditListState from "../types/AuditListState";
import {State} from "../../../store";
import useSelector from "../../common/hooks/useSelector";

export default function useAuditListSelector<TSelected>(selector: (state: AuditListState) => TSelected, equalityFn?: (left: TSelected, right: TSelected) => boolean): TSelected {
    const reselect = createSelector((state: State) => state.auditList, selector);
    return useSelector(reselect, equalityFn);
}